module.exports = __webpack_public_path__ + "img/enigmatic_synthesis.c01069da.jpg";